var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgContactIcon = function SvgContactIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.375,
    d: "M13.459 30.083h-.792c-6.333 0-9.5-1.584-9.5-9.5v-7.917c0-6.333 3.167-9.5 9.5-9.5h12.667c6.333 0 9.5 3.167 9.5 9.5v7.917c0 6.333-3.167 9.5-9.5 9.5h-.792c-.49 0-.966.237-1.267.633L20.9 33.883c-1.045 1.393-2.755 1.393-3.8 0l-2.375-3.167c-.253-.348-.839-.633-1.266-.633Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.375,
    d: "M11.083 12.666h15.833M11.083 20.584h9.5",
    opacity: 0.4
  })));
};
export default SvgContactIcon;